import { motion } from 'motion/react';
import TagsSelector from '../../../Tags';
import styles from './Tags.module.css';

const Tags = (_) => {
    return (
        <div className={styles.container}>
            <motion.div
                className={styles.content}
                initial={{ opacity: 0, y: 8 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.2 }}
            >
                <TagsSelector reference="details" />
            </motion.div>
        </div>
    );
};

export default Tags;
